import { store } from "src/store/configureStore"
import { LanguageUnion, TranslationKey, languages } from "./useTranslate"

const state = store.getState()
const ln:LanguageUnion = state.language.current || 'en'

const t = (key: TranslationKey) => {
  return languages[ln][key]
}

export default t